import { Mount } from "@pdfking/reactivity/preact"
import { RecordMerge } from "@pdfking/tfunc"
import element from "../dom/element"

function extract_data_attributes(el: HTMLElement): Record<string, string> {
  const result: Record<string, string> = {}
  for (const attr of el.attributes) {
    if (attr.name.startsWith("data-")) {
      result[attr.name.slice(5)] = attr.value
    }
  }
  return result
}

export const init = (
  Component: any,
  el?: HTMLElement,
  props?: Record<string, unknown>
) => {
  const merged = RecordMerge(el ? extract_data_attributes(el) : {}, props || {})
  return Mount(
    () => <Component {...merged} />,
    el || document.body.appendChild(element("div"))
  )
}

export const replace = (
  Component: any,
  el: HTMLElement,
  props?: Record<string, unknown>
) => {
  const merged = RecordMerge(extract_data_attributes(el), props || {})
  const node = Mount(() => <Component {...merged} />, element("div"))
  el.replaceWith(node)
}
